module.exports = __webpack_public_path__ + "img/message.32bb965a.svg";